import type { Device as DeviceModel } from '@/adapters/catalogv1.g';

export function extractDevice(model: DeviceModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.device_ref ?? '',
    name: model.name ?? '',
    deviceType: model.device_type,
    isCompliant: model.is_compliant,
    isManaged: model.is_managed,
    lastSeenAt: model.last_seen_at ? new Date(model.last_seen_at) : undefined,
    manufacturer: model.manufacturer,
    model: model.model,
    operatingSystem: model.operating_system,
    osVersion: model.os_version,
    serialNumber: model.serial_number,
    trustType: model.trust_type,
    enrollmentDate: model.enrollment_date
      ? new Date(model.enrollment_date)
      : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogDevice = ReturnType<typeof extractDevice>;
